import { format } from "date-fns";
import api from "../services/api";

interface ITopSalesResponse {
    codeResult: string;
    data: any[];
}

export interface ITopSalesParams {
    year: string;
    month: string;
    min: number;
    max: number;
    status: string;
    tipo: string;

}
export interface ITopSales {
    numero: number;
    revendedor: string;
    representante: string;
    status: number;
    cidade: number;
    valorVendido: number;
    celular: string;
}


class TopSalesRepository {
    public async TopSales({ year, month, min, max, status, tipo }: ITopSalesParams): Promise<ITopSales[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Revendedor", "Representante", "Conference", "Kit"],
            "sql": [
                {
                    "coderesult": "TopSales",
                    "query": `SELECT Kit.numero as Numero, 
                    Revendedor.nome as Nome, 
                    Revendedor.status as Status, 
                    Revendedor.cidade as Cidade, 
                    Revendedor.celular as Celular, 
                    Conference.valorVendido as ValorVendido,
                    Representante.nome as NomeRP
                    FROM Kit 
                    LEFT JOIN Revendedor 
                    ON Revendedor.id = Kit.revendedorId 
                    LEFT JOIN Representante
                    ON Representante.id = Revendedor.representanteId
                    INNER JOIN Conference 
                    ON Conference.kitId = Kit.id 
                    WHERE Kit.statusKit IN(8,5) 
                    AND Kit.estado NOT IN(1,2) 
                    AND Kit.tipo IN(${tipo}) 
                    AND Conference.conferenceType = 0
                    AND Conference.data >= '${initialDate}' 
                    AND Conference.data < '${endDate}' 
                    AND Conference.valorVendido >= ${min} 
                    AND Conference.valorVendido <= ${max} 
                    AND Revendedor.status IN(${status}) 
                    ORDER BY Conference.valorVendido DESC`
                }
            ]
        };

        const response = await api.post<ITopSalesResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "TopSales").map(result => {
            return {
                numero: result.Numero,
                representante: result.NomeRP,
                revendedor: result.Nome,
                status: result.Status,
                cidade: result.Cidade,
                valorVendido: result.ValorVendido,
                celular: result.Celular
            }
        });
    }

    GetFromCodeResult(data: ITopSalesResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const topSalesRepository = new TopSalesRepository();
export default topSalesRepository;